import { toast } from "react-toastify";
import { getUserData, getUserId } from "../../../Base/helper/baseFunctions";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_LMS_API_URL } from "../../../../Constants/baseConstant";


// Helper for fetching report schedules
export const GetReportScheduleHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/ancillary/lms/getReportSchedule`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: params?.domain_name || data.domain,
        },
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

// Helper for updating report schedules
export const UpdateReportScheduleHelper = async (params) => {
    var data = getUserData();
    toast.info("Saving...");
    return await axiosInstance(`/ancillary/lms/updateReportSchedule`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            reports_list_fk: params?.reports_list?.reports_list,
            email: params?.email,
            occurence: params?.schedule_id?.occurence,
            days_of_week: params?.days_of_week
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Report Scheduled Updated Successfully");
            return { message: "Success", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

// Helper for deleting report schedules
export const DeleteReportScheduleHelper = async (params) => {
    var data = getUserData();
    toast.info("Deleting...");
    return await axiosInstance(`/ancillary/lms/deleteReportSchedule`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            report_scheduling_details_id: params?.report_scheduling_details_id,
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Report Scheduled Deleted Successfully");
            return { message: "Success", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const GetReportListHelper = async (params) => {
    return await axiosInstance(`/ancillary/lms/getReportlist`, {
        method: "GET",
        baseURL: HRMS_LMS_API_URL,
        data: {
        },
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};